import React, { useEffect, useState } from 'react'
import Floatingbutton from './Floatingbutton'
import Addusersmodal from '../SuperAdminmodal/Addusersmodal'
import Conformationdeleteusermodal from '../SuperAdminmodal/Conformationdeleteusermodal'
import config from '../../config'
import axios from 'axios'
import { toast } from 'react-toastify'
import { useMemo } from 'react'

const SingleUserunitplan = () => {
  const [showModal, setShowModal] = useState(false)
  const [selectId, setSelectId] = useState(null)
  const [deleteId, setDeleteId] = useState(null)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [users, setUsers] = useState([])
  const [inputData, setInputData] = React.useState([])
  const [rolls, setRolls] = React.useState([])

  useEffect(() => {
    if (showModal) {
      fetchinputs()
    }
  }, [showModal])

  useEffect(()=>{
    peginationdata()
  },[])



  useEffect(() => {
    fetchinputs()
  }, [])

  useEffect(() => {
    fetchrolls()
  }, [])

  useEffect(() => {
    if (showModal) {
      fetchrolls()
    }
  }, [showModal])

  const fetchinputs = async () => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.get(
        `${config.apiUrl}/projects/projects-with-wings`,
        {
          headers: { Authorization: token }
        }
      )
      console.log('FULL API RESPONSE:', res.data)
      const normalized = (res.data || []).flatMap(project =>
        (project.Wings || []).map(wing => ({
          projectId: project.ID,
          projectName: project.Name.trim(),
          wingId: wing.ID,
          wingName: wing.Name
        }))
      )
      setInputData(normalized)
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch posts')
    }
  }

  const fetchrolls = async () => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.get(`${config.apiUrl}/roles/list`, {
        headers: { Authorization: token }
      })

      console.log('ROLES ARRAY:', res.data.data)
      const normalized = (res.data.data || []).map(roll => ({
        rollId: roll.ID,
        rollName: roll.Name
      }))

      setRolls(normalized)
    } catch (err) {
      console.error(err)
      // toast.error('Failed to fetch posts')
    }
  }

  const peginationdata = async () => {
  const token = localStorage.getItem('token')

  try {
    const res = await axios.get(
      `${config.apiUrl}/flat-details`,
      { headers: { Authorization: token } }
    )

    console.log("API RESPONSE:", res.data)

    // ✅ Convert object to array
    const item = res.data.data

    if (!item) return

    setUsers([{
      id: item.ID,
      username: item.MembersName?.trim() || '',
      RoomNo: `${item.BldgNo || ''} / ${item.FlatNo || ''}`,
      CurrentAreaCASqft: item.CurrentAreaCASqft || '',
      EligibleAreaCAPlus50PercentSqft: item.EligibleAreaCAPlus50PercentSqft || '',
      NearestAreaAsPerPlanSqft: item.NearestAreaAsPerPlanSqft || '',
      FlatSizeOptedAsPerScheme: item.FlatSizeOptedAsPerScheme || 'NA',
      DifferenceInAreaSqft6Minus5: item.DifferenceInAreaSqft6Minus5 || 'NA',
      AdditionalAreaAsPerSchemeI7Minus5: item.AdditionalAreaAsPerSchemeI7Minus5 || 'NA',
      JodiFlat: item.JodiFlat || 'NA',
      ExtraFlatSchemeII: item.ExtraFlatSchemeII || 'NA',
      deletedOn: item.DeletedOn
    }])

  } catch (err) {
    console.error("API ERROR:", err.response || err)
    toast.error('Failed to load users')
  }
}

 

  const handleConfirmDelete = async () => {
    if (!deleteId) return

    const token = localStorage.getItem('token')
    try {
      await axios.delete(`${config.apiUrl}/user/delete/${deleteId}`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        }
      })

     
      setUsers(prev => prev.filter(user => user.id !== deleteId))

      toast.success('User deleted successfully!')
      setShowConfirmModal(false)
      setDeleteId(null)
    } catch (e) {
      console.error(e)
      toast.error('Failed to delete user')
    }
  }

  

 
  



  const projectMap = useMemo(() => {
    const map = {}
    inputData.forEach(item => {
      if (!map[item.projectId]) {
        map[item.projectId] = item.projectName
      }
    })
    return map
  })
  console.log(projectMap)

  const RollsName = useMemo(() => {
    const rollmap = {}
    rolls.forEach(item => {
      if (!rollmap[item.rollId]) {
        rollmap[item.rollId] = item.rollName
      }
    })
    return rollmap
  })
  console.log(RollsName)

  const handlemodalOpen = id => {
    setSelectId(id)
    setShowModal(true)
  }

  const handleDeleteModal = id => {
    setDeleteId(id)
    setShowConfirmModal(true)
  }

  const handleCancelDelete = () => {
    setShowConfirmModal(false)
    setDeleteId(null)
  }

  return (
    <div id="app-Capsule">
      <div className="pt-4">
        <h2 style={{paddingTop:'2rem', textAlign:'center'}}>Single Users Unit Plan</h2>
        <div
  className="table-responsive-sm pt-5"
  style={{
    maxHeight: '100vh',
    overflowY: 'auto'
  }}
>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th className="text-center text-bold fs-6">Sr.No</th>
                <th className="text-center text-bold fs-6">Name</th>
                <th className="text-center fs-6 text-bold">Bldg No./ FlatNo</th>
                <th className='text-center fs-6 text-bold'>CurrentAreaCASqft</th>
                <th className='text-center fs-6 text-bold'>EligibleAreaCAPlus50PercentSqft</th>
                <th className='text-center fs-6 text-bold'>NearestAreaAsPerPlanSqft</th>
                <th className='text-center fs-6 text-bold'>FlatSizeOptedAsPerScheme</th>
                <th className='text-center fs-6 text-bold'>DifferenceInAreaSqft6Minus5</th>
                <th className='text-center fs-6 text-bold'>AdditionalAreaAsPerSchemeI7Minus5</th>
                <th className='text-center fs-6 text-bold'>JodiFlat</th>
                <th className='text-center fs-6 text-bold'>ExtraFlatSchemeII</th>
                <th className="text-center fs-6 text-bold">Delete User</th>
              </tr>
            </thead>

            <tbody>
              {users.map((user, index) => (
                <tr
                  key={user.id}
                  className="text-center"
                  style={{
                    cursor: user.deletedOn ? 'not-allowed' : 'pointer',
                    // color: user.deletedOn ? 'red' : 'inherit',
                    background: user.deletedOn ? 'rgb(220 220 220)' : 'inherit'
                  }}
                >
                  <th scope="row">{index + 1}</th>
                   <td className="text-bold">{user.username}</td>
                   <td className='text-bold'>{user.RoomNo}</td>

  <td className="text-bold">{user.CurrentAreaCASqft}</td>

  <td className="text-bold">{user.EligibleAreaCAPlus50PercentSqft}</td>

  <td className="text-bold">{user.NearestAreaAsPerPlanSqft}</td>

  <td className="text-bold">{user.FlatSizeOptedAsPerScheme}</td>

  <td className="text-bold">{user.DifferenceInAreaSqft6Minus5}</td>

  <td className="text-bold">{user.AdditionalAreaAsPerSchemeI7Minus5}</td>

  <td className="text-bold">{user.JodiFlat}</td>

  <td className="text-bold">{user.ExtraFlatSchemeII}</td>
                  
                  {/* <th>{projectMap[user.ProjectID] || '—'}</th> */}
                  {/* <th>{RollsName[user.roleId] || '—'}</th> */}
                  {/* <th>{user.Wing}</th> */}
                 
                  
                  <th>
                    <div
                      className="rounded-circle"
                      style={{
                        backgroundColor: 'red',
                        width: '30px',
                        height: '30px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                        cursor: user.deletedOn ? 'not-allowed' : 'pointer',
                        zIndex: 10,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: 'auto',
                        filter: user.deletedOn ? 'blur(2px)' : 'none',
                        opacity: user.deletedOn ? 0.5 : 1
                      }}
                      onClick={() => {
                        if (!user.deletedOn) {
                          handleDeleteModal(user.id)
                        }
                      }}
                    >
                      <ion-icon
                        name="trash"
                        style={{ fontSize: '15px', color: 'white' }}
                      />
                    </div>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-center"style={{
        paddingBottom: "5rem",
        paddingTop: "1rem"
      }}>
        {/* <div className="text-muted small" style={{ paddingLeft: '12px' }}>
          Showing <strong>{startRow}</strong> to <strong>{endRow}</strong> of{' '}
          <strong>{pagination.totalRecords}</strong> Rows
        </div> */}
      </div>

      <Floatingbutton onOpen={() => setShowModal(true)} />
      <Addusersmodal
        show={showModal}
        userId={selectId}
        // createusers={createusers}
        fetchinputs={fetchinputs}
        inputData={inputData}
        rolls={rolls}
        onClose={() => setShowModal(false)}
      />
      <Conformationdeleteusermodal
        show={showConfirmModal}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    </div>
  )
}

export default SingleUserunitplan